<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> Tevkifat Bağlantıları</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-flex xs12 sm3 md5 mr-5 v-if="!viewType">
              <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search3"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>
            </v-flex>

            <v-tooltip bottom>
            
            
             
            </v-tooltip>

            <!-- <v-menu offset-y v-if="!viewType">
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile >
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile >
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu> -->
          </v-toolbar>
        </v-flex>

        <!-- Sıralama ve Filtreleme -->
        <v-flex xs12 sm12 md12>
          <v-card width="100%" flat color="grey lighten-5" class="pl-3 pr-3">
            <v-layout row wrap align-center>
              <v-flex
                xs12
                sm12
                md9
                class="headline font-weight-regular pl-3 grey--text"
              >
               
              </v-flex>
             
             
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pt-2 v-if="!viewType">
          <v-container fluid grid-list-sm>
            <v-flex>
              <v-data-table
                :rows-per-page-items="[100]"
                :headers="headersCardItems"
                :items="cardItems"
                :search="search3"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-left">
                      {{ props.item.Id }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.HesapKodu }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.HesapAdi }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TevkifatHesapKodu }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TevkifatHesapAdi }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.TevkifatKodu }}
                    </td>
                  
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- sayfalama -->
    <template v-if="vmodelpagination">
      <div class="text-xs-center">
        <v-container>
          <v-layout justify-center>
            <v-flex xs8>
              <v-pagination
                color="info"
                v-model="searchData.Paging.PageNo"
                :length="pagenumber"
                :total-visible="1"
                @input="getListItems()"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
  data() {
    return {
      search3: "",
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      siralamaItems: [
        {
          Text: "Koda Göre Azalan",
          Value: 1,
        },
        {
          Text: "Koda Göre Artan",
          Value: 0,
        },
        {
          Text: "Kod Adına Göre Artan",
          Value: 2,
        },
        {
          Text: "Kod Adına Göre Azalan",
          Value: 3,
        },
      ],
      totalCountText: null,
      pagenumber: 0,
      vmodelpagination: false,
      accoutingCode: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        MainCodeInfo: {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
        },
        Code: null,
        CodeName: null,
        AccountGroup: null,
        AccountCodeInfo: {
          SirketKodu: 0,
          Kod: null,
          Unvan: null,
          Unvani2: null,
          MuhasebeKodu: null,
          VergiDaire: null,
          VergiNo: null,
          TCNo: null,
        },
        ForeignCurrencyCode: false,
        Currency: null,
        BalanceType: 0, //0 : tüm 1: alacak 2:borç
        CodeActivePassive: false,
        ActivePassiveDate: null,
        ActivePassiveUserID: 0,
        CodeLocked: false,
        LockedDate: null,
        LockedUserID: 0,
        AlternativeCode: null,
        AlternativeCodeName: null,
        ReferanceForced: false,
        CostCenterForced: false,
        RootCode: false,
        SectionCodeForced: false,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: null,
        LogList: [],
      },
      headersCardItems: [
        {
          text: "Id",
          value: "Id",
        },
        {
          text: "Hesap Kodu",
          value: "HesapKodu",
        },
        {
          text: "Hesap Adi",
          value: "HesapAdi",
        },
        {
          text: "Tevkifat Hesap Kodu",
          value: "TevkifatHesapKodu",
        },
        {
          text: "Tevkifat Hesap Adi",
          value: "TevkifatHesapAdi",
        },
        {
          text: "Tevkifat Kodu",
          value: "TevkifatKodu",
        },
      ],
      cardItems: [],
     
      viewType: false, //false: Treeview true: cardView
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: true,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      searchData: {
       
        AccountingCompanyID: 0,
       
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  methods: {
  
    getListItems() {
      this.loadingvmodel = true;
      this.searchData.AccountingCompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingParameters/WithHoldingRelationsList",
          this.searchData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.cardItems = response.body;
            this.loadingvmodel = false;
            
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-WithHoldingRelationsList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-WithHoldingRelationsList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {


    this.loadingvmodel = true;
    this.getListItems();

  },
  watch: {
    viewType: function (val) {
      if (!val && this.cardItems.length == 0) {
        //Card Yapısı Çekiliyor
        this.getListItems();
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style>
</style>

